exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-comp .error-message{display:none}.form-comp.show-errors .form-question-comp:not(.is-valid){color:#ff0300}.form-comp.show-errors .form-question-comp:not(.is-valid) .error-message{display:block}.form-comp.show-errors .form-question-comp:not(.is-valid) input{border-color:#ff0300}", ""]);

// exports
